import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { PERMISSION } from 'src/features/auth';
import { membershipMessages } from 'src/features/memberships/utils/messages';
import { vehicleMessages } from 'src/features/vehicles/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';

const VehiclesLayout = () => {
    const { formatMessage } = useIntl();
    const permissionStay = useHasPermissions([PERMISSION.VEHICLE_STAY]);
    const permissionMembership = useHasPermissions([PERMISSION.VEHICLE_MEMBERSHIP]);
    const permissionFullLog = useHasPermissions([PERMISSION.VEHICLE_FULL_LOG]);
    const permissionReservations = useHasPermissions([PERMISSION.RESERVATIONS]);
    const permissionSubscriptions = useHasPermissions([PERMISSION.SUBSCRIPTIONS]);

    return (
        <MainLayout>
            <TabRow>
                {permissionStay && (
                    <Tab end to="/vehicles">
                        {formatMessage(vehicleMessages.inParking)}
                    </Tab>
                )}
                {permissionMembership && (
                    <Tab to="/vehicles/memberships">{formatMessage(membershipMessages.membershipGroups)}</Tab>
                )}
                {permissionSubscriptions && (
                    <Tab end to="/vehicles/subscriptions">
                        {formatMessage(vehicleMessages.subscriptions)}
                    </Tab>
                )}
                {permissionReservations && (
                    <Tab end to="/vehicles/reservations">
                        {formatMessage(vehicleMessages.reservations)}
                    </Tab>
                )}
                {permissionFullLog && (
                    <Tab end to="/vehicles/full-log">
                        {formatMessage(vehicleMessages.fullLog)}
                    </Tab>
                )}
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};

export default VehiclesLayout;
